<script setup lang="ts">
import { usePageContext } from '@/composables/usePageContext'
import HelpLayout from '../HelpLayout.vue'
import HelpCategory from '@/ui-kit/help/Category.vue'

interface Category {
  category_id: number
  category_code: string
  category_name: string
  articles: Array<{ id: number; title: string; code_name: string }>
}

interface CenterContext {
  categories: Category[]
}

const ctx = usePageContext<CenterContext>()
</script>

<template>
  <HelpLayout contact-form-category="help">
    <div class="help-center__categories">
      <HelpCategory v-for="(cat, key) in ctx.categories" v-bind="cat" :key="key" />
    </div>
  </HelpLayout>
</template>

<style lang="scss">
@use '@/styles/pages/help/center.scss' as *;
</style>
